<ng-container *ngIf="isLoaded()">
  <ng-container *ngIf="isAperturaModal (); else container">
    <sub-header [isModal]="true" [includeContextHelp]="true" [windowHash]="windowHash"></sub-header>
    <p-scrollPanel [style]="{width: '100%', height: '70vh'}" styleClass="custombar1">
      <ng-container [ngTemplateOutlet]="container"></ng-container>
    </p-scrollPanel>
  </ng-container>
</ng-container>
<ng-template #container>
  <div class="col-12">
    <formElement [model]="this" [fieldConfig]="getBuscadorDivisionTree()" (valueChanged)="changeDivision ()">
    </formElement>
  </div>
  <div class="col-12">
    <p-tabView>
      <!-- 1. REGLAS MANDATORY -->
      <p-tabPanel *ngIf="isShowMandatoryRules()" [selected]="true">
        <ng-template pTemplate="header">{{'DossierActions.general' | translate}} <span class="badge badge-warning"
            *ngIf="this.actionNumberVisible && mandatoryActions && mandatoryActions.length > 0">
            {{mandatoryActions.length }}</span>
        </ng-template>
        <ng-container [ngTemplateOutlet]="actionGroup" [ngTemplateOutletContext]="{
                actions: mandatoryActions,
                groups: groupMandatoryActions,
                evaluationError: evaluationError
              }">
        </ng-container>
      </p-tabPanel>
      <!-- 2. REGLAS OPCIONALES (SI NO HAY ACCIONES NO APARECE EL TAB) -->
      <p-tabPanel *ngIf="
              isShowOptionalRules() && (otherActions && otherActions.length > 0)
            ">
        <ng-template pTemplate="header">{{'DossierActions.optional' | translate}} <span class="badge badge-warning"
            *ngIf="this.actionNumberVisible && otherActions && otherActions.length > 0"> {{ otherActions.length
            }}</span>
        </ng-template>
        <ng-container [ngTemplateOutlet]="actionGroup" [ngTemplateOutletContext]="{
                actions: otherActions,
                groups: groupOtherActions,
                evaluationError: evaluationError
              }">
        </ng-container>
      </p-tabPanel>
    </p-tabView>
  </div>
</ng-template>
<!-- TEMPLATE CON EL LISTADO DE ACCIONES -->
<ng-template #actionGroup let-actions="actions" let-groups="groups" let-evaluationError="evaluationError">
  <ng-container *ngIf="!evaluationError && actions && actions.length > 0; else noMandatoryActions">
    <div class="col-12 p-0 plyca-actions ">
      <!-- NO AGRUPAMOS LAS REGLAS DE LA DIVISION RAIZ-->
      <ng-container *ngIf="_getSimpleIdentifierFromString (groups[0].division?.identifier) == '0'">
        <ng-container [ngTemplateOutlet]="actionList" [ngTemplateOutletContext]="{ divisionGroup: groups[0] }">
        </ng-container>
      </ng-container>
      <!-- DIVISIONES DE PRIMER NIVEL AGRUPADAS -->
      <ng-container *ngFor="let divisionGroup of groups">
        <div class="m-b-2 mb-2">
          <p-fieldset [toggleable]="true"
            *ngIf="_getSimpleIdentifierFromString (divisionGroup.division?.identifier) != '0'">
            <p-header><i aria-hidden="true" class="fas fa-lg fa-file-contract mr-2"></i>
              <!--span
                                *ngIf="divisionGroup.documentClass">{{divisionGroup.documentClass.name}} -</span--><span
                style="white-space: break-spaces;">{{divisionGroup.division.name}} </span>
              <span class="badge badge-warning" *ngIf="this.actionNumberVisible"> {{ divisionGroup.count }}</span>
            </p-header>
            <ng-container [ngTemplateOutlet]="actionList" [ngTemplateOutletContext]="{ divisionGroup: divisionGroup }">
            </ng-container>
          </p-fieldset>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-template>
<!-- TEMPLATE PARA REPRESENTAR UN GRUPO, SUS REGLAS Y SUS GRUPOS ANIDADOS -->
<ng-template #actionList let-divisionGroup="divisionGroup">
  <!-- 1. REGLAS DEL GRUPO -->
  <ng-container *ngIf="divisionGroup?.rules?.length>0 || divisionGroup?.actionsListGroupMetadata?.length>0 "
    [ngTemplateOutlet]="actionsTable" [ngTemplateOutletContext]="{ actionList: divisionGroup.rules,
      actionsListGroupMetadata: divisionGroup.actionsListGroupMetadata }">
  </ng-container>
  <!-- <ng-container *ngFor="let rule of divisionGroup.rules; let rowIndex = index">
        <ng-container [ngTemplateOutlet]="action" [ngTemplateOutletContext]="{ rowData: rule }">
        </ng-container>
    </ng-container> -->
  <!-- 2. GRUPOS ANIDADOS Y SUS REGLAS DEL -->
  <ng-container *ngIf="divisionGroup.groups">
    <div class="col-12 pt-0 pb-2 mb-1">
      <p-accordion [multiple]="true" (onOpen)="storeState($event, true, divisionGroup.groups)"
        (onClose)="storeState($event, false, divisionGroup.groups)">
        <ng-container *ngFor="let _group of divisionGroup.groups">
          <p-accordionTab [selected]="_group.opened || this.divisionId">
            <p-header>
              <span><i aria-hidden="true" class="far fa-folder-open fa-lg mr-1"></i>
                <!--span
                                    *ngIf="_group.division.documentClass">{{_group.division.documentClass.name}} -
                                </span--> {{ _group.division.name}} </span>
              <span class="ml-2 badge badge-warning" *ngIf="this.actionNumberVisible">{{ _group.rules.length }}</span>
            </p-header>
            <ng-container [ngTemplateOutlet]="actionsTable"
              [ngTemplateOutletContext]="{ actionList: _group.rules, actionsListGroupMetadata: _group.actionsListGroupMetadata  }">
            </ng-container>
            <!-- <ng-container *ngFor="let rule of _group.rules; let rowIndex = index">
                            <ng-container [ngTemplateOutlet]="action" [ngTemplateOutletContext]="{ rowData: rule }">
                            </ng-container>
                        </ng-container> -->
          </p-accordionTab>
        </ng-container>
      </p-accordion>
    </div>
  </ng-container>
</ng-template>
<!-- LISTADO DE ACCIONES EN MODO TABLE -->
<ng-template #actionsTable let-actionsList="actionList" let-actionsListGroupMetadata="actionsListGroupMetadata">
  <p-table [value]="actionsList" sortMode="single" [scrollable]="false" responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <tr>
        <th class="icon-col"></th>
        <th style="width:45%;">{{'General.action'|translate}}</th>
        <th class="TEXTTH-w200 d-none d-lg-table-cell">{{'DossierActions.to'|translate}}</th>
        <th class="DATETIMETH d-none d-lg-table-cell ">{{'DossierActions.from'|translate}}</th>
        <th class="DATETIMETH d-none d-lg-table-cell ">{{'DossierActions.expiration'|translate}}</th>
        <th class="action-column text-right"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-action let-rowIndex="rowIndex">
      <tr
        *ngIf="stateGrouping && actionsListGroupMetadata && action.state && actionsListGroupMetadata[action.state].index === rowIndex">
        <td [attr.colspan]="COLUMN_COUNT">
          <!-- <img [alt]="customer.representative.name" src="assets/showcase/images/demo/avatar/{{customer.representative.image}}" width="32" style="vertical-align: middle" /> -->
          <span class="p-text-bold p-ml-2 badge {{getStateDescription (action.state)?.icon}}">{{getStateDescription
            (action.state)?.description}}</span>
        </td>
      </tr>
      <ng-container [ngTemplateOutlet]="actionTPL" [ngTemplateOutletContext]="{ action: action }">
      </ng-container>
    </ng-template>
  </p-table>
</ng-template>
<!-- TEMPLATE PARA RENDERIZAR ACCION INDIVIDUAL -->
<ng-template #actionTPL let-action="action">
  <!-- BLOQUEADA (TEMPLATE NORMAL) -->
  <ng-container *ngIf="isLocked(action)" [ngTemplateOutlet]="generalAction"
    [ngTemplateOutletContext]="{ action: action }">
  </ng-container>
  <!-- REGLA PARA EJECUTAR (TEMPLATE NORMAL) -->
  <ng-container *ngIf="!(isRuleDTO(action) && action.type === undefined) && isExecutableAndNotLocked(action)"
    [ngTemplateOutlet]="generalAction" [ngTemplateOutletContext]="{ action: action }">
  </ng-container>
  <!-- REGLA EN EJECUCION (TEMPLATE NORMAL) -->
  <ng-container *ngIf="(isRuleDTO(action) && (isRuleRunnig(action) || isRuleFinished(action))) "
    [ngTemplateOutlet]="generalAction" [ngTemplateOutletContext]="{ action: action }">
  </ng-container>
  <!-- REGLA SIN TIPO (MENSAJE) -->
  <ng-container *ngIf="isRuleDTO(action) && action.type === undefined" [ngTemplateOutlet]="emptyAction"
    [ngTemplateOutletContext]="{ action: action }">
  </ng-container>
  <!-- REGLA FICTICIA DE AGRUPACION -->
  <ng-container *ngIf="isGroupingRule (action)" [ngTemplateOutlet]="groupingAction"
    [ngTemplateOutletContext]="{ action: action }">
  </ng-container>
</ng-template>
<!-- TEMPLATE QUE PINTA UNA ACCION NORMAL-->
<ng-template #generalAction let-action="action">
  <tr>
    <td class="icon-col"><span *ngIf="action?.relatedTasks?.length > 0"><i class="fa fa-lg fa-angle-down"
          aria-hidden="true"></i></span>
    </td>
    <td (click)="execute(action)" [ngStyle]="{'cursor': (isExecutableAndNotLocked(action)) ? 'pointer' : ''}">
      <span [ngStyle]="{ 'margin-left': calculateDeepMargin(action) + 'px' }"  pTooltip="{{ getTooltip(action) }}" tooltipPosition="bottom">
        <i class="fas fa-lg {{ getIcon(action) }} d-inline" style=" {{ getStyle(action) }} " aria-hidden="true"></i> {{getDescription (action)}}<i
          *ngIf="isNecessary (action)" class="ml-2 fa fa-warning text-warning"></i>
      </span>
      <!-- 4. EN MOVIL FECHAS DE LLEGADA Y VENCIMIENTO -->
      <div class="d-lg-none">
        <div class="" *ngIf="action['inbox']">
          <b>{{'DossierActions.to'|translate}}: </b>
          <a *ngIf="action['inbox']?.description" aria-expanded="false" title="{{ 'General.visualize' | translate}}"
            (click)="showInbox(action['inbox'])">
            <i class="fas fa-inbox" aria-hidden="true"> </i>
            <span class="d-sm-inline">
              {{action['inbox']?.description?action['inbox']?.description:action['inbox']?.identifier}}</span>
          </a>
        </div>
        <div class="" *ngIf="action['arrivalDate']">
          <b>{{ 'DossierActions.from' | translate }}:</b>
          <formatDataValue [type]="'DATETIME'" [value]="action['arrivalDate'] " [valueClassObject]="'d-inline'">
          </formatDataValue>
        </div>
        <div class="" *ngIf="action['expirationDate']">
          <b>{{ 'DossierActions.expiration' | translate }}:</b>
          <formatDataValue [type]="'DATETIME'" [value]="action['expirationDate'] " [valueClassObject]="'d-inline'">
          </formatDataValue>
        </div>
      </div>
      <span class="float-lg-right"><ng-container [ngTemplateOutlet]="showProfiles"
          [ngTemplateOutletContext]="{ action: action }">
        </ng-container>
      </span>
      <ng-container [ngTemplateOutlet]="lockedAction" [ngTemplateOutletContext]="{ action: action }"
        *ngIf="isLocked(action) && getLockedBy(action)">
      </ng-container>
    </td>
    <td class="TEXTTH-w200 d-none d-lg-table-cell">
      <a *ngIf="action['inbox']?.description" aria-expanded="false" title="{{ 'General.visualize' | translate}}"
        (click)="showInbox(action['inbox'])">
        <i class="fas fa-inbox" aria-hidden="true"> </i>
        <span class="d-none d-sm-inline">
          {{action['inbox']?.description?action['inbox']?.description:action['inbox']?.identifier}}</span>
      </a>
    </td>
    <td class="DATETIMETH d-none d-lg-table-cell ">
      <formatDataValue [type]="'DATETIME'" [value]="action['arrivalDate'] ">
      </formatDataValue>
    </td>
    <td class="DATETIMETH d-none d-lg-table-cell ">
      <formatDataValue [type]="'DATETIME'" [value]="action['expirationDate'] ">
      </formatDataValue>
    </td>
    <td class="action-column text-right">
      <ng-container>
        <button class="btn btn-secondary btn-sm t-action-button" aria-expanded="false"
          title="{{this?.commandActionButton[action.identifier]?.title}}"
          *ngIf="!this.showActionButton[action.identifier]"
          (click)="this.executeButtonCommand($event, action.identifier)">
          <i class="{{this?.commandActionButton[action.identifier]?.icon}}" aria-hidden="true"></i>
        </button>
        <button class="btn btn-secondary btn-sm t-action-button" aria-expanded="false" (click)="menu.toggle($event)"
          *ngIf="this?.showActionButton[action.identifier]">
          <i class="fa fa-cog dropdown-toggle" aria-hidden="true"></i>
        </button>
        <p-menu #menu [model]="getActionMenuItems (action)" [popup]="true" appendTo="body"></p-menu>
      </ng-container>
    </td>
  </tr>
  <ng-container *ngIf="action.relatedTasks">
    <tr *ngFor="let action of action.relatedTasks">
      <td class="icon-col"></td>
      <td (click)="execute(action)" style="cursor:pointer;">
        <!-- <span style="margin-left: 15px;">-->
        <span [ngStyle]="{ 'margin-left': calculateDeepMargin(action) + 'px' }">
          <i aria-hidden="true" class="fas fa-lg {{ getIcon(action) }} "></i> {{getDescription (action) }} </span>
        <span class="float-right">
          <ng-container [ngTemplateOutlet]="showProfiles" [ngTemplateOutletContext]="{ action: action }">
          </ng-container>
        </span>
      </td>
      <td><span *ngIf="action['inbox']">{{ action['inbox']?.description }}</span></td>
      <td><span *ngIf="action['arrivalDate']">{{ action['arrivalDate'] | date: 'dd/MM/yyyy HH:mm'}}</span></td>
      <td><span *ngIf="action.expirationDate">{{ action.expirationDate | date: 'dd/MM/yyyy HH:mm'}}</span></td>
      <td>
        <ng-container>
          <button class="btn btn-secondary btn-sm" aria-expanded="false" (click)="menu.toggle($event)">
            <i class="fa fa-cog dropdown-toggle" aria-hidden="true"></i>
          </button>
          <p-menu #menu [model]="getActionMenuItems (action)" [popup]="true" appendTo="body"></p-menu>
        </ng-container>
      </td>
    </tr>
  </ng-container>
</ng-template>
<!-- TEMPLATE PARA REGLAS DE AGRUPACION -->
<ng-template #groupingAction let-action="action">
  <tr>
    <td class="icon-col"></td>
    <td [attr.colspan]="COLUMN_COUNT-1">
      <h4 style="_border-bottom-style: groove;_padding-bottom: 5px;"
        [ngStyle]="{ 'margin-left': calculateDeepMargin(action) + 'px' }">
        <span><i class="fas fa-1-5x fa-folder mr-1"></i>{{getActionGroupText (action)}} {{ getDescription(action)
          }}</span>
      </h4>
    </td>
  </tr>
</ng-template>
<!-- TEMPLATE PARA REGLA SIN ACCION (MENSAJE) -->
<ng-template #emptyAction let-action="action">
  <tr class="alert alert-info">
    <td class="icon-col"></td>
    <td [attr.colspan]="COLUMN_COUNT-1">
      <div class="alert alert-info w-100 list-element mb-0  pl-1 pr-1" role=" alert"
        [ngStyle]="{ 'margin-left': calculateDeepMargin(action) + 'px' }">
        <span>
          <i aria-hidden="true" class="fas fa-lg {{ getIcon(action) }} "></i> {{ getDescription(action) }} <ng-container
            [ngTemplateOutlet]="showProfiles" [ngTemplateOutletContext]="{ action: action }">
          </ng-container>
        </span>
      </div>
    </td>
  </tr>
  <!-- </div> -->
</ng-template>
<!-- TEMPLATE PARA CUANDO NO HAY ACCIONES -->
<ng-template #noMandatoryActions let-error="evaluationError">
  <div class="row">
    <div class="col-12">
      <div [ngClass]="(evaluationError)?'widget style1 bg-warning':'widget style1 bg-info'">
        <div class="row">
          <div class="col-4">
            <i class="fas fa-info fa-3x"></i>
          </div>
          <div class="col-8 text-right">
            <h2 class="font-bold">
              <div *ngIf="!evaluationError"> {{ 'DossierActions.noData' | translate }} </div>
              <div *ngIf="evaluationError != null">{{evaluationError}}</div>
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!-- TEMPLATE PARA PINTAR PERFILES -->
<ng-template #showProfiles let-action="action">
  <span *ngIf="showActionProfiles(action)" class="badge badge-info border border-secondary pt-0 pb-0"><small> {{
      getProfiles(action) }} </small></span>
</ng-template>
<!-- TEMPLATE PARA ACCION BLOQUEADA -->
<ng-template #lockedAction let-action="action">
  <div class="text-left w-100" pTooltip="{{
   userService.calculateUserFullName(getLockedBy(action)) }}" tooltipPosition="bottom">
    <span class="d-inline"> [ {{ 'Tasks.lockedBy' | translate }}: {{ getLockedBy(action).identifier }}] {{
      userService.calculateUserFullName(getLockedBy(action)) }}</span>
  </div>
</ng-template>